
import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import FloatingButtons from '../../components/feature/FloatingButtons';

const AboutPage = () => {
  const whatsappMessage = encodeURIComponent('Merhaba, izmirtentetamir.net web siteniz üzerinden yazıyorum.');

  useEffect(() => {
    document.title = 'Hakkımızda - İzmir Tente Tamir | Profesyonel Tente Hizmetleri';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'İzmir Tente Tamir olarak 15 yılı aşkın deneyimimizle İzmir genelinde kaliteli tente tamiri ve yenileme hizmetleri sunuyoruz. Müşteri memnuniyeti odaklı çalışma anlayışımızla yanınızdayız.');
    }
  }, []);

  const values = [
    { icon: 'ri-shield-check-line', title: 'Güvenilirlik', description: 'Müşterilerimize verdiğimiz sözleri tutarak güven oluşturuyoruz' },
    { icon: 'ri-star-line', title: 'Kalite', description: 'En kaliteli malzemeler ve işçilikle uzun ömürlü çözümler sunuyoruz' },
    { icon: 'ri-time-line', title: 'Hızlı Hizmet', description: 'Zamanında teslimat ve hızlı müdahale ile yanınızdayız' }
  ];

  const stats = [
    { number: '15+', label: 'Yıllık Deneyim' },
    { number: '500+', label: 'Mutlu Müşteri' },
    { number: '%100', label: 'Memnuniyet' },
    { number: '24/7', label: 'Destek' }
  ];

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: 'Inter, sans-serif' }}>
      <Header />
      <FloatingButtons />

      <section className="pt-20 pb-10 md:pt-24 md:pb-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <div>
              <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Hakkımızda
              </h1>
              <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
                <strong>İzmir Tente Tamir</strong>, İzmir genelinde tente tamiri, tente yenileme ve gölgelendirme sistemleri alanında profesyonel çözümler sunan uzman bir firmadır. Konutlardan ticari alanlara kadar geniş bir hizmet yelpazesiyle müşterilerimize dayanıklı, uzun ömürlü ve estetik çözümler üretmekteyiz.
              </p>
              <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
                Müşteri memnuniyetini ve kaliteli işçiliği ön planda tutarak, hızlı müdahale ve şeffaf hizmet anlayışıyla çalışıyoruz. Deneyimli ekibimiz ve modern ekipmanlarımızla her türlü tente ihtiyacınıza profesyonel çözümler sunuyoruz.
              </p>
              <ul className="space-y-2">
                <li className="flex items-start space-x-2 text-sm text-gray-700">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-1.5 flex-shrink-0"></span>
                  <span>15 yılı aşkın sektör deneyimi</span>
                </li>
                <li className="flex items-start space-x-2 text-sm text-gray-700">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-1.5 flex-shrink-0"></span>
                  <span>Kaliteli malzeme ve işçilik garantisi</span>
                </li>
                <li className="flex items-start space-x-2 text-sm text-gray-700">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-1.5 flex-shrink-0"></span>
                  <span>Hızlı ve güvenilir servis hizmeti</span>
                </li>
                <li className="flex items-start space-x-2 text-sm text-gray-700">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-1.5 flex-shrink-0"></span>
                  <span>Uygun fiyat ve şeffaf ödeme koşulları</span>
                </li>
              </ul>
            </div>
            <div className="rounded-2xl overflow-hidden shadow-xl w-full h-64 md:h-80 lg:h-96">
              <img
                src="https://public.readdy.ai/ai/img_res/e5c5211fb1cf4b14f0268f5e5e485448.jpg"
                alt="İzmir Tente Tamir Ekibi"
                className="w-full h-full object-cover object-top"
                loading="eager"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="py-10 md:py-16 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-8">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900">Değerlerimiz</h2>
          </div>
          <div className="grid grid-cols-3 gap-3 md:gap-8">
            {values.map((value, index) => (
              <div key={index} className="text-center">
                <div className="w-10 h-10 md:w-14 md:h-14 flex items-center justify-center bg-gray-100 rounded-full mx-auto mb-2 md:mb-4">
                  <i className={`${value.icon} text-lg md:text-2xl text-gray-900`}></i>
                </div>
                <h3 className="text-xs md:text-lg font-semibold text-gray-900 mb-1">{value.title}</h3>
                <p className="text-xs text-gray-600 hidden md:block">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-10 md:py-16 px-4 sm:px-6 lg:px-8 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-8">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900">Sayılarla Biz</h2>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-8">
            {stats.map((stat, index) => (
              <div key={index} className="text-center bg-white rounded-xl p-4">
                <div className="text-2xl md:text-4xl font-bold text-gray-900 mb-1">{stat.number}</div>
                <div className="text-xs text-gray-600">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-10 md:py-16 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
            Tente İhtiyaçlarınız İçin Bize Ulaşın
          </h2>
          <p className="text-sm text-gray-600 mb-6">
            Profesyonel ekibimiz size en uygun çözümü sunmak için hazır
          </p>
          <div className="flex flex-row gap-3 justify-center">
            <a
              href="tel:+905513723512"
              className="px-5 py-2.5 bg-gray-900 hover:bg-gray-800 text-white text-xs font-semibold rounded-lg transition-colors cursor-pointer whitespace-nowrap"
            >
              Hemen Ara
            </a>
            <a
              href={`https://wa.me/905513723512?text=${whatsappMessage}`}
              target="_blank"
              rel="noopener noreferrer"
              className="px-5 py-2.5 border-2 border-gray-900 hover:bg-gray-50 text-gray-900 text-xs font-semibold rounded-lg transition-colors cursor-pointer whitespace-nowrap"
            >
              WhatsApp ile İletişim
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutPage;
